export class ErpType {
    public Erp: string;

    public Version: string;
}